<script setup>
import { computed, ref } from 'vue';
import { useIntervalFn } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { CUSTOMER_RECEIPT_STATUS } from 'dashboard/helper/customerReceiptHelper';

import Icon from 'next/icon/Icon.vue';

const { status } = defineProps({
  status: {
    type: String,
    required: true,
    validator: value => Object.values(CUSTOMER_RECEIPT_STATUS).includes(value),
  },
});

const { t } = useI18n();

const progresIconSequence = [
  'i-lucide-clock-1',
  'i-lucide-clock-2',
  'i-lucide-clock-3',
  'i-lucide-clock-4',
  'i-lucide-clock-5',
  'i-lucide-clock-6',
  'i-lucide-clock-7',
  'i-lucide-clock-8',
  'i-lucide-clock-9',
  'i-lucide-clock-10',
  'i-lucide-clock-11',
  'i-lucide-clock-12',
];

const progessIcon = ref(progresIconSequence[0]);

const rotateIcon = () => {
  const currentIndex = progresIconSequence.indexOf(progessIcon.value);
  const nextIndex = (currentIndex + 1) % progresIconSequence.length;
  progessIcon.value = progresIconSequence[nextIndex];
};

useIntervalFn(rotateIcon, 500, {
  immediate: status === CUSTOMER_RECEIPT_STATUS.PROGRESS,
  immediateCallback: false,
});

const statusIcon = computed(() => {
  const statusIconMap = {
    [CUSTOMER_RECEIPT_STATUS.UNREAD]: 'i-lucide-circle',
    [CUSTOMER_RECEIPT_STATUS.READ]: 'i-lucide-circle-check',
    [CUSTOMER_RECEIPT_STATUS.FAILED]: 'i-lucide-circle-alert',
  };

  return statusIconMap[status];
});

const statusColor = computed(() => {
  const statusIconMap = {
    [CUSTOMER_RECEIPT_STATUS.UNREAD]: 'text-n-slate-9',
    [CUSTOMER_RECEIPT_STATUS.READ]: 'text-n-teal-11',
    [CUSTOMER_RECEIPT_STATUS.FAILED]: 'text-n-ruby-11',
  };

  return statusIconMap[status];
});

const tooltipText = computed(() => {
  const statusTextMap = {
    [CUSTOMER_RECEIPT_STATUS.UNREAD]: t('CONVERSATION.UNREAD_MESSAGE'),
    [CUSTOMER_RECEIPT_STATUS.READ]: t('CHAT_LIST.MESSAGE_READ'),
    [CUSTOMER_RECEIPT_STATUS.FAILED]: t('CHAT_LIST.FAILED_TO_SEND'),
    [CUSTOMER_RECEIPT_STATUS.PROGRESS]: t('CHAT_LIST.SENDING'),
  };

  return statusTextMap[status];
});
</script>

<template>
  <Icon
    v-if="status === CUSTOMER_RECEIPT_STATUS.PROGRESS"
    v-tooltip.top-start="tooltipText"
    :icon="progessIcon"
    class="text-n-slate-9"
  />
  <Icon
    v-else
    v-tooltip.top-start="tooltipText"
    :icon="statusIcon"
    :class="statusColor"
    class="size-[14px]"
  />
</template>
